import { ElementRef, EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import { BaseComponent } from '../../../../shared/base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../../session/session.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ResourceForHelpService } from '../../../resource-for-help/resource-for-help.service';
import { MessageService } from '../../../message/message.service';
import { UserService } from '../../../../core/user/user.service';
import { OfflineMessageService } from '../offline-message.service';
import { JhiEventManager } from '../../../../ng-jhipster/service';
import { AccountService } from '../../../../core/auth/account.service';
import { WhatsappService } from '../../../session/whatsapp.service';
import { Conversationn } from '../../../../shared/model/conversationn.model';
import { Account } from '../../../../core/user/account.model';
import { Router } from "@angular/router";
import { CancelSessionDialogComponent } from '../../../session/cancel-session-dialog/cancel-session-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../session/session.service";
import * as i2 from "../../../message/message.service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../../resource-for-help/resource-for-help.service";
import * as i5 from "../../../../core/user/user.service";
import * as i6 from "../../../session/whatsapp.service";
import * as i7 from "../../../../core/auth/account.service";
import * as i8 from "../offline-message.service";
import * as i9 from "@ng-bootstrap/ng-bootstrap";
import * as i10 from "../../../../ng-jhipster/service";
import * as i11 from "@angular/router";
import * as i12 from "@angular/common";
import * as i13 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i14 from "@angular/forms";
import * as i15 from "../../../../shared/modal-success/modal-success.component";
import * as i16 from "@fortawesome/angular-fontawesome";
import * as i17 from "@ngx-translate/core";
const _c0 = ["reportClientModal"];
const _c1 = ["additionalHelpModal"];
const _c2 = ["emailInboxMessagesModal"];
const _c3 = ["alreadyFutureSessionDialog"];
const _c4 = ["alreadyFutureSessionDialogForCoach"];
function OfflineMessageControlDropdownComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵelement(1, "img", 18);
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵelement(1, "img", 18);
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 20);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.openReportClientModal(); });
    i0.ɵɵtext(1, "Report Person");
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 21);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_8_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.bookSession(); });
    i0.ɵɵtext(1, "Book Session");
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_10_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.cancelSession("reschedule"); });
    i0.ɵɵtext(1, "Reschedule Session");
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.cancelSession("cancel"); });
    i0.ɵɵtext(1, "Cancel Session");
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_14_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.sendWellbeingScan(ctx_r27.selectedConversation.user.id); });
    i0.ɵɵtext(1, "Send wellbeing scan");
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_a_16_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.emailSelectedMessages(ctx_r29.inboxMessagesList); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "sessionChat.paragraph.emailSelected"));
} }
const _c5 = function (a1) { return ["/session/chat-coach", a1]; };
function OfflineMessageControlDropdownComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵtext(1, "Extend Session");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c5, ctx_r8.session == null ? null : ctx_r8.session.id));
} }
function OfflineMessageControlDropdownComponent_ng_template_19_div_0_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "small", 36);
} }
function OfflineMessageControlDropdownComponent_ng_template_19_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelement(2, "h3", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "textarea", 32);
    i0.ɵɵlistener("ngModelChange", function OfflineMessageControlDropdownComponent_ng_template_19_div_0_Template_textarea_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.reasonOfFlagging = $event; });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, OfflineMessageControlDropdownComponent_ng_template_19_div_0_small_7_Template, 1, 0, "small", 33);
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 34);
    i0.ɵɵelementStart(10, "button", 35);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_ng_template_19_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.reportClient(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 3, "sessionChat.placeholder.enter"));
    i0.ɵɵproperty("ngModel", ctx_r32.reasonOfFlagging);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r32.showReasonOfFlaggingRequired);
} }
function OfflineMessageControlDropdownComponent_ng_template_19_modal_success_1_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "modal-success", 37);
    i0.ɵɵlistener("dismissed", function OfflineMessageControlDropdownComponent_ng_template_19_modal_success_1_Template_modal_success_dismissed_0_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.onDismiss($event); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("titleText", "sessionChat.title.done")("message", i0.ɵɵpipeBind1(1, 2, ctx_r33.reportSuccessMessage));
} }
function OfflineMessageControlDropdownComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, OfflineMessageControlDropdownComponent_ng_template_19_div_0_Template, 11, 5, "div", 27);
    i0.ɵɵtemplate(1, OfflineMessageControlDropdownComponent_ng_template_19_modal_success_1_Template, 2, 4, "modal-success", 28);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r10.flagged);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.flagged);
} }
function OfflineMessageControlDropdownComponent_ng_template_21_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "fa-icon", 43);
    i0.ɵɵelement(2, "span", 44);
    i0.ɵɵelement(3, "p", 45);
    i0.ɵɵelementEnd();
} }
function OfflineMessageControlDropdownComponent_ng_template_21_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul", 46);
    i0.ɵɵelementStart(2, "li", 47);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_ng_template_21_div_4_Template_li_click_2_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.selectedTab = "COMPANY"; });
    i0.ɵɵelementStart(3, "a", 48);
    i0.ɵɵtext(4, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "li", 47);
    i0.ɵɵlistener("click", function OfflineMessageControlDropdownComponent_ng_template_21_div_4_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r44); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.selectedTab = "NATIONAL"; });
    i0.ɵɵelementStart(6, "a", 49);
    i0.ɵɵtext(7, "National");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 50);
    i0.ɵɵelementStart(9, "div", 51);
    i0.ɵɵelementStart(10, "p");
    i0.ɵɵtext(11, "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 52);
    i0.ɵɵelementStart(13, "p");
    i0.ɵɵtext(14, "Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit, sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(ctx_r42.selectedTab === "COMPANY" ? ctx_r42.tabSelected : ctx_r42.tabUnSelected);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(ctx_r42.selectedTab === "NATIONAL" ? ctx_r42.tabSelected : ctx_r42.tabUnSelected);
} }
function OfflineMessageControlDropdownComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelement(2, "h6", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, OfflineMessageControlDropdownComponent_ng_template_21_div_3_Template, 4, 0, "div", 40);
    i0.ɵɵtemplate(4, OfflineMessageControlDropdownComponent_ng_template_21_div_4_Template, 15, 4, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r12.isConfirmed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isConfirmed);
} }
function OfflineMessageControlDropdownComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 53);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("titleText", "sessionChat.header.selectedMessages")("message", i0.ɵɵpipeBind1(1, 2, ctx_r14.emailInboxMessagesModalMessage));
} }
function OfflineMessageControlDropdownComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 53);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.alreadyFutureSessionMessage"));
} }
function OfflineMessageControlDropdownComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 53);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("titleText", "")("message", i0.ɵɵpipeBind1(1, 2, "sessionSchedule.dialog.alreadyFutureSessionMessageForCoach"));
} }
export class OfflineMessageControlDropdownComponent extends BaseComponent {
    constructor(sessionService, messageService, sessionStorage, resourceForHelpService, userService, whatsappService, accountService, offlineMessageService, modalService, eventManager, router) {
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.resourceForHelpService = resourceForHelpService;
        this.userService = userService;
        this.whatsappService = whatsappService;
        this.accountService = accountService;
        this.offlineMessageService = offlineMessageService;
        this.modalService = modalService;
        this.eventManager = eventManager;
        this.router = router;
        this.messageChange = new EventEmitter();
        this.bookSessionChange = new EventEmitter();
        this.inboxMessagesList = [];
        this.isIndex = this.router.url.includes('index');
        this.isConfirmed = false;
        this.selectedTab = 'COMPANY';
        this.tabSelected = { 'border-bottom': '2px solid black', 'font-weight': 'bold' };
        this.tabUnSelected = { 'border-bottom': '1px solid grey' };
        this.reasonOfFlagging = '';
        this.flagged = false;
    }
    ngOnInit() {
        this.inboxMessagesListSubscription = this.eventManager.subscribe('inboxMessagesList', (response) => {
            this.inboxMessagesList = response.content;
            console.log(this.inboxMessagesList);
        });
        this.sessionService.futureControl(this.sessionStorage.retrieve("userId")).subscribe(response2 => {
            this.futureSessionExists = response2.body && response2.body.length > 0;
            if (this.futureSessionExists)
                this.futureSession = response2.body[0];
            this.sessionStorage.clear("userId");
        });
        this.selectedConversationChangedSubscription = this.eventManager.subscribe('selectedConversationChanged', (response1) => {
            let userId = response1.content;
            this.sessionService.futureControl(userId).subscribe(response2 => {
                this.futureSessionExists = response2.body && response2.body.length > 0;
                if (this.futureSessionExists)
                    this.futureSession = response2.body[0];
            });
        });
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
    }
    resourcesLoaded() {
        return this.resources && this.resources.length > 0;
    }
    reportClient() {
        this.showReasonOfFlaggingRequired = false;
        this.flagged = false;
        if (this.reasonOfFlagging === '') {
            this.showReasonOfFlaggingRequired = true;
            return;
        }
        this.userService.reportClient2({ id: 0, reasonOfFlagging: this.reasonOfFlagging }, this.selectedConversation.user.id).subscribe(res => {
            this.flagged = true;
        }, error => console.error('client cannot be flagged: ' + error));
    }
    onDismiss($event) {
        // console.log('captured dismiss');
        this.flagged = false;
    }
    openReportCoachModal() {
        this.reportSuccessMessage = 'sessionChat.messages.coachIsFlagged';
        this.modalService.open(this.reportClientModal);
    }
    openReportClientModal() {
        this.reportSuccessMessage = 'sessionChat.messages.clientIsFlagged';
        this.modalService.open(this.reportClientModal);
    }
    openAdditionalHelpModal() {
        this.modalService.open(this.additionalHelpModal);
    }
    deleteAll() {
        this.offlineMessageService.deleteAllMessages(this.selectedConversation.user.id).subscribe(() => {
            this.messageChange.emit([]);
        });
    }
    bookSession() {
        let triggeredByCoach = this.accountService.isCoach();
        this.bookSessionChange.emit(triggeredByCoach);
    }
    cancelSession(type) {
        const modalRef = this.modalService.open(CancelSessionDialogComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.sessionId = this.futureSession.id;
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.selectedConversation = this.selectedConversation;
    }
    emailSelectedMessages(inboxMessagesList) {
        inboxMessagesList.sort((a, b) => a.id - b.id);
        this.messageService.inboxMessagesList = inboxMessagesList;
        console.log(this.messageService.inboxMessagesList);
        this.messageService.emailInboxMessages(this.messageService.inboxMessagesList).subscribe((response) => {
            console.log(response);
            if (response.ok) {
                this.emailInboxMessagesModalMessage = 'sessionChat.messages.selectedMessagesSuccess';
                this.open(this.emailInboxMessagesModal);
                for (let i = 0; i < this.messageService.inboxMessagesList.length; i++) {
                    this.messageService.inboxMessagesList[i].chosenToBeEmailed = false;
                }
                this.messageService.inboxMessagesList = [];
                this.inboxMessagesList = [];
            }
        }, () => {
            console.log('fail');
            this.emailInboxMessagesModalMessage = 'sessionChat.messages.selectedMessagesFail';
            this.open(this.emailInboxMessagesModal);
        });
    }
    ngOnDestroy() {
        if (this.inboxMessagesListSubscription) {
            this.inboxMessagesListSubscription.unsubscribe();
        }
        if (this.selectedConversationChangedSubscription) {
            this.selectedConversationChangedSubscription.unsubscribe();
        }
    }
    sendWellbeingScan(id) {
        let subscription = this.messageService.startWellbeingScan(id, 0).subscribe((res) => {
            alert("Self-scan has been started");
        }, error => {
            alert("Error starting self-scan" +
                (error.status === 424 ? "\nSession must be booked for the user" : ""));
        });
    }
}
OfflineMessageControlDropdownComponent.ɵfac = function OfflineMessageControlDropdownComponent_Factory(t) { return new (t || OfflineMessageControlDropdownComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.ResourceForHelpService), i0.ɵɵdirectiveInject(i5.UserService), i0.ɵɵdirectiveInject(i6.WhatsappService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.OfflineMessageService), i0.ɵɵdirectiveInject(i9.NgbModal), i0.ɵɵdirectiveInject(i10.JhiEventManager), i0.ɵɵdirectiveInject(i11.Router)); };
OfflineMessageControlDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OfflineMessageControlDropdownComponent, selectors: [["offline-message-control-dropdown"]], viewQuery: function OfflineMessageControlDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportClientModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.additionalHelpModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailInboxMessagesModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialogForCoach = _t.first);
    } }, inputs: { selectedConversation: "selectedConversation", currentAccount: "currentAccount", canBookSession: "canBookSession", session: "session" }, outputs: { messageChange: "messageChange", bookSessionChange: "bookSessionChange" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 29, vars: 9, consts: [[1, "ah-actions", "actions", "align-items-center"], [1, "dropdown"], ["href", "", "data-toggle", "dropdown", "style", "transform: rotate(90deg);", "class", "d-none d-lg-block", 4, "ngIf"], ["href", "", "data-toggle", "dropdown", "class", "d-md-block d-lg-none", 4, "ngIf"], [1, "dropdown-menu", "dropdown-menu-right"], ["class", "dropdown-item", "jhiTranslate", "inukaNgApp.offlineMessage.Report Person", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "inukaNgApp.offlineMessage.Book Session", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "sessionSchedule.header.rescheduleSession", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "sessionSchedule.header.cancelSession", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "global.Send wellbeing scan", 3, "click", 4, "ngIf"], ["class", "dropdown-item", 3, "click", 4, "ngIf"], ["class", "dropdown-item", "jhiTranslate", "sessionChat.button.extendSession", 3, "routerLink", 4, "ngIf"], ["reportClientModal", ""], ["additionalHelpModal", ""], ["emailInboxMessagesModal", ""], ["alreadyFutureSessionDialog", ""], ["alreadyFutureSessionDialogForCoach", ""], ["href", "", "data-toggle", "dropdown", 1, "d-none", "d-lg-block", 2, "transform", "rotate(90deg)"], ["src", "../../../../../../../../../../../../content/images/inuka/add-filled-2x.png", 2, "width", "auto", "height", "2.5rem", "line-height", "16.5rem", "font-size", "1rem"], ["href", "", "data-toggle", "dropdown", 1, "d-md-block", "d-lg-none"], ["jhiTranslate", "inukaNgApp.offlineMessage.Report Person", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "inukaNgApp.offlineMessage.Book Session", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "sessionSchedule.header.rescheduleSession", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "sessionSchedule.header.cancelSession", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "global.Send wellbeing scan", 1, "dropdown-item", 3, "click"], [1, "dropdown-item", 3, "click"], ["jhiTranslate", "sessionChat.button.extendSession", 1, "dropdown-item", 3, "routerLink"], ["class", "modal-body", 4, "ngIf"], [3, "titleText", "message", "dismissed", 4, "ngIf"], [1, "modal-body"], [1, "text-center", "my-4"], ["jhiTranslate", "sessionChat.header.reason"], ["rows", "5", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["jhiTranslate", "sessionChat.paragraph.reason", 4, "ngIf"], [1, "text-center"], ["type", "button", "jhiTranslate", "sessionChat.button.submit", 1, "btn-2", "btn-2-black", 3, "click"], ["jhiTranslate", "sessionChat.paragraph.reason"], [3, "titleText", "message", "dismissed"], [2, "background-color", "#FFFB99!important"], ["jhiTranslate", "inukaNgApp.offlineMessage.additionalHelp", 1, "tab-header"], ["class", "align-items-center justify-content-center", "style", "text-align: center;", 4, "ngIf"], [4, "ngIf"], [1, "align-items-center", "justify-content-center", 2, "text-align", "center"], ["icon", "lock"], ["jhiTranslate", "inukaNgApp.offlineMessage.notAllowed", 1, "tab-header", 2, "padding-left", "4px"], ["jhiTranslate", "inukaNgApp.offlineMessage.availableOptions"], ["role", "tablist", 1, "nav", "nav-justified", "md-tabs", "bottom-shadow"], [1, "nav-item", "tab-header", 3, "click"], ["data-toggle", "tab", "href", "#company", "role", "tab", "aria-controls", "company", "aria-selected", "true", "jhiTranslate", "inukaNgApp.offlineMessage.company", 1, "nav-link", "active", "tab-a"], ["data-toggle", "tab", "href", "#national", "role", "tab", "aria-controls", "national", "aria-selected", "false", "jhiTranslate", "inukaNgApp.offlineMessage.national", 1, "nav-link", "tab-a"], [1, "tab-content", "pt-4"], ["id", "company", "role", "tabpanel", "aria-labelledby", "company-tab", 1, "tab-pane", "fade", "show", "active"], ["id", "national", "role", "tabpanel", "aria-labelledby", "national-tab", 1, "tab-pane", "fade"], [3, "titleText", "message"]], template: function OfflineMessageControlDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵelementStart(1, "li", 1);
        i0.ɵɵtemplate(2, OfflineMessageControlDropdownComponent_a_2_Template, 2, 0, "a", 2);
        i0.ɵɵtemplate(3, OfflineMessageControlDropdownComponent_a_3_Template, 2, 0, "a", 3);
        i0.ɵɵelementStart(4, "ul", 4);
        i0.ɵɵelementStart(5, "li");
        i0.ɵɵtemplate(6, OfflineMessageControlDropdownComponent_a_6_Template, 2, 0, "a", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "li");
        i0.ɵɵtemplate(8, OfflineMessageControlDropdownComponent_a_8_Template, 2, 0, "a", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "li");
        i0.ɵɵtemplate(10, OfflineMessageControlDropdownComponent_a_10_Template, 2, 0, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "li");
        i0.ɵɵtemplate(12, OfflineMessageControlDropdownComponent_a_12_Template, 2, 0, "a", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "li");
        i0.ɵɵtemplate(14, OfflineMessageControlDropdownComponent_a_14_Template, 2, 0, "a", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "li");
        i0.ɵɵtemplate(16, OfflineMessageControlDropdownComponent_a_16_Template, 3, 3, "a", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "li");
        i0.ɵɵtemplate(18, OfflineMessageControlDropdownComponent_a_18_Template, 2, 3, "a", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, OfflineMessageControlDropdownComponent_ng_template_19_Template, 2, 2, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(21, OfflineMessageControlDropdownComponent_ng_template_21_Template, 5, 2, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(23, OfflineMessageControlDropdownComponent_ng_template_23_Template, 2, 4, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(25, OfflineMessageControlDropdownComponent_ng_template_25_Template, 2, 4, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(27, OfflineMessageControlDropdownComponent_ng_template_27_Template, 2, 4, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.inboxMessagesList.length !== 0 || ctx.canBookSession);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inboxMessagesList.length !== 0 || ctx.canBookSession);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.canBookSession);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isIndex && !ctx.futureSessionExists);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isIndex && ctx.futureSessionExists);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isIndex && ctx.futureSessionExists);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.canBookSession && ctx.selectedConversation.user.whatsappConversationId);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.inboxMessagesList.length !== 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.session == null ? null : ctx.session.minutesLeftToSessionStart) <= 0 && (ctx.session == null ? null : ctx.session.minutesLeftToSessionEnd) > 0);
    } }, directives: [i12.NgIf, i13.JhiTranslateDirective, i11.RouterLinkWithHref, i14.DefaultValueAccessor, i14.NgControlStatus, i14.NgModel, i15.ModalSuccessComponent, i16.FaIconComponent], pipes: [i17.TranslatePipe], styles: [".tab-header[_ngcontent-%COMP%]{text-transform:uppercase;color:#000 !important;border:none}.bottom-shadow[_ngcontent-%COMP%]{box-shadow:0 8px 6px -6px #222}.tab-a[_ngcontent-%COMP%]{color:#000;margin:0 auto}"] });
